import React, { cloneElement } from 'react';
import { useParams } from 'react-router-dom';

const WithRouterParams = ({ children }) => {
  return cloneElement(children, { params: useParams() });
};

export default WithRouterParams;